<template>
  <div style="display: flex">
    <btn-download
      :label="$t('app.contratacoes.components.buttons.dwonload.label')"
      :row="row"
      confirm-text="Baixar como PDF o boleto da contratação"
      confirm-title="Baixar contratação?"
      fault-error="Falha ao baixar contratação!"
      fault-file-name="contratacao_:id"
      success-text="Succeso ao baixar o PDF do boleto da contratação"
      tipo-operacao="PRORROGACAO"
    />
    <v-btn
      class="ma-2"
      flat
      @click="confirmarAcaoAlterarData()"
    >
      <v-icon left>
        mdi-calendar-blank
      </v-icon> {{ this.$t('app.contratacoes.components.buttons.transferDate.label') }}
    </v-btn>
    <v-btn
      class="ma-2"
      flat
      :disabled="habilitarBaixarInvalidar"
      @click="confirmarAcaoBaixar()"
    >
      <v-icon left>
        mdi-check
      </v-icon> {{ this.$t('app.contratacoes.components.buttons.terminate.label') }}
    </v-btn>
    <v-btn
      class="ma-2"
      flat
      :disabled="habilitarBaixarInvalidar"
      @click="confirmarAcaoInvalidar()"
    >
      <v-icon left>
        mdi-close
      </v-icon> {{ this.$t('app.contratacoes.components.buttons.invalidate.label') }}
    </v-btn>
    <dialog-atualizar-repasse
      :dialog.sync="dialog"
      :row="row"
    />
  </div>
</template>

<script>
import NotificationMixin from 'Support/mixins/notification-mixin';
import RouterMixin from 'Support/mixins/router-mixin';
import ContratacoesRequest from 'Domain/contratacoes/ContratacoesRequest';
import DialogAtualizarRepasse from 'App/contratacoes/components/botoes-acao/DialogAtualizarRepasse.vue';
import ActionButtonsMixin from 'Support/mixins/ActionButtonsMixin';
import BtnDownload from 'Support/components/buttons/BtnDownloadBoleto.vue';

export default {
  name: 'BotaoAcao',
  components: {
    DialogAtualizarRepasse,
    BtnDownload,
  },
  mixins: [NotificationMixin, RouterMixin, ActionButtonsMixin],
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    habilitarBaixarInvalidar() {
      return !['ABERTA', 'VENCIDA'].includes(this.row.statusDaContratacao.toUpperCase()) || false;
    },
  },
  methods: {
    confirmarAcaoAlterarData() {
      this.dialog = true;
    },
    confirmarAcaoManual(acao) {
      this.confirmarAcao(
        this.$t('app.contratacoes.components.buttons.terminate.dialog.title'),
        this.$t('app.contratacoes.components.buttons.terminate.dialog.message'),
        this.$t('app.contratacoes.list.confirm'),
        this.$t('app.contratacoes.list.cancel'),
        acao,
      );
    },
    confirmarAcaoBaixar() {
      this.confirmarAcaoManual(this.baixarProrrogacao);
    },
    confirmarAcaoInvalidar() {
      this.confirmarAcaoManual(this.invalidarProrrogacao);
    },
    invalidarProrrogacao() {
      this.callService(ContratacoesRequest.manuallyInvalidate(this.row.id), 'refresh-crud',
        {
          successTitle: this.$t('app.contratacoes.list.successTitle'),
          successMessage: this.$t('app.contratacoes.list.successMessage'),
          errorTitle: this.$t('app.contratacoes.list.errorTitle'),
          errorMessage: this.$t('app.contratacoes.list.errorMessage'),
        });
    },
    baixarProrrogacao() {
      this.callService(ContratacoesRequest.manuallyTerminate(this.row.id), 'refresh-crud',
        {
          successTitle: this.$t('app.contratacoes.list.successTitle'),
          successMessage: this.$t('app.contratacoes.list.successMessage'),
          errorTitle: this.$t('app.contratacoes.list.errorTitle'),
          errorMessage: this.$t('app.contratacoes.list.errorMessage'),
        });
    },
  },
};
</script>
<style scoped>
.v-icon--left {
    margin-right: 7px !important;
}
</style>
